module.exports = __webpack_public_path__ + "static/media/google.c09e4004.svg";